import React from 'react';
import LoadingSpinner from './LoadingSpinner';

const LoadingFallback = ({ message = "Loading..." }) => {
  return (
    <div className="min-h-screen bg-neutral-100/70 flex items-center justify-center px-4">
      <div className="rounded-3xl border border-neutral-200 bg-white p-8 text-center shadow-sm">
        <LoadingSpinner />
        <p className="mt-4 text-sm font-medium text-charcoal-600">{message}</p>
      </div>
    </div>
  );
};

export default LoadingFallback; 